import Auth from '../auth/Auth';
import EmailTemplate from "../models/EmailTemplate";
import MessageOptoutType from "../models/MessageOptoutType";
import TemplateTag from "../models/TemplateTag";
import { WebClient } from './WebClient'

class ApiEmailTemplates extends WebClient {
    async getEmailTemplates(): Promise<EmailTemplate[]> {
        const url = `/emailtemplates`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async saveEmailTemplate(emailTemplate: EmailTemplate): Promise<EmailTemplate> {
        const url = `/emailtemplates`;

        return this.post(url, emailTemplate, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }

    async deleteEmailTemplate(emailTemplateId: number): Promise<boolean> {
        const url = `/emailtemplates/${emailTemplateId}`;

        return this.delete(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async sendEmailActiveCustomers(emailTemplateId: number): Promise<boolean> {
        const url = `/emailtemplates/sendtoall/${emailTemplateId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async sendEmailToCustomerList(emailTemplateId: number, customerIds: number[]): Promise<boolean> {
        const url = `/emailtemplates/sendtolist/${emailTemplateId}`;
        
        return this.post(url, customerIds, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }
    
    async getMessageOptoutTypes(): Promise<MessageOptoutType[]> {
        const url = `/emailtemplates/optouts`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }
    
    async getTemplateTags(): Promise<TemplateTag[]> {
        const url = `/emailtemplates/tags`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async getSignupTemplateIds(): Promise<number[]> {
        const url = `/emailtemplates/signup`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async setSignupTemplateIds(templateIds: number[]): Promise<boolean> {
        const url = `/emailtemplates/signup`;

        return this.put(url, templateIds, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async getReactivationTemplateIds(): Promise<number[]> {
        const url = `/emailtemplates/reactivation`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async setReactivationTemplateIds(templateIds: number[]): Promise<boolean> {
        const url = `/emailtemplates/reactivation`;

        return this.put(url, templateIds, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }
}

export default new ApiEmailTemplates();
